import { useMemo, useState } from 'react'

type Props = {
  label: string
  options: string[]
  selected: string[]
  onChange: (next: string[]) => void
  searchable?: boolean
}

export function ChipGroup({ label, options, selected, onChange, searchable = false }: Props) {
  const [q, setQ] = useState('')

  const filtered = useMemo(
    () => (q ? options.filter((o) => o.toLowerCase().includes(q.toLowerCase())) : options),
    [options, q],
  )

  function toggle(opt: string) {
    onChange(selected.includes(opt) ? selected.filter((s) => s !== opt) : [...selected, opt])
  }
  function selectAll() {
    if (!q) return onChange(options.slice())
    const next = new Set(selected)
    for (const o of filtered) next.add(o)
    onChange([...next])
  }
  function clear() { onChange([]) }

  return (
    <div style={{ marginBottom: 14 }}>
      <div className="between" style={{ marginBottom: 8 }}>
        <div className="label">{label} · {selected.length} / {options.length}</div>
        <div>
          <button type="button" className="link" onClick={selectAll}>Select all</button>
          {' · '}
          <button type="button" className="link" onClick={clear}>Clear</button>
        </div>
      </div>

      {searchable && options.length > 10 && (
        <div className="search">
          <span style={{ color: 'var(--text-muted)' }}>⌕</span>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" />
        </div>
      )}

      <div className="row">
        {filtered.map((o) => (
          <button
            key={o}
            type="button"
            className={`chip ${selected.includes(o) ? 'on' : ''}`}
            onClick={() => toggle(o)}
          >
            {o}
          </button>
        ))}
      </div>
    </div>
  )
}
